const initReviewsSlider = () => {
  const root = document.querySelector('[data-reviews-container]');
  if (!root) {
    return;
  }

  const container = root.querySelector('[data-reviews-swiper]');
  if (!container) {
    return;
  }

  const btnPrev = root.querySelector('[data-slider-prev]');
  const btnNext = root.querySelector('[data-slider-next]');

  new Swiper(container, {
    slidesPerView: 'auto',
    speed: 500,
    spaceBetween: 20,
    grabCursor: true,
    watchOverflow: true,
    resistanceRatio: 0.85,
    navigation: {
      prevEl: btnPrev,
      nextEl: btnNext,
    },
    breakpoints: {
      808: {
        spaceBetween: 25,
      }
    }
  });
};

export { initReviewsSlider };
